var map = {
	"./ajax.png": "92c5",
	"./borussia.png": "4548",
	"./celtic.png": "db57",
	"./france.png": "17a5",
	"./hjk2.png": "bf99",
	"./milan.png": "decd",
	"./mtd.png": "6218",
	"./sampdoria.png": "e534",
	"./spfc.png": "6551"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1b81";